import { IconButton, Menu, Grid, MenuItem, Tooltip } from '@material-ui/core';
import { Button, Divider, MobileStepper } from '@material-ui/core';
import { ChevronRight, DateRange, Description, KeyboardArrowLeft, KeyboardArrowRight, MoreHoriz, Room, EventBusy, Phone, Schedule, Work, CalendarToday, Email } from '@material-ui/icons';
import DonutSmallIcon from '@material-ui/icons/DonutSmall';
import {
  breakContract,
  getInfoStudentOnTeam,
  getStudentAffiliate,
  getAllInvitation,
  getTrainingById,
  setTeamMemberAction,
  setAffiliateAction,
  getJobsById,
  getBusinessById,
  getContractTypesById,
  responseInvitationAffiliation,
  getAbsenceHoursByStudentIdAndClassroomId,
  getRemainingDays,
} from '@webapps/business';
import HourglassHalf from 'components/Icons/HourglassHalf';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import MessageBox from 'components/MessageBox';
import Modal from 'components/Modal';
import ModalConfirm from 'components/ModalConfirm/ModalConfirm';
import PropTypes from 'prop-types';
import { useEffect, useState, useMemo } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Affiliate from './Affiliate';
import AffiliateCorrection from './AffiliateCorrection';
import theme from './theme';
import { OPCO_STATUS, ROUTES_PATH, RYTHME_SCOLAIRE } from 'config/constants';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import Invite from './Invites';
import Information from 'components/Icons/Information';
import { formatPhoneNumber } from 'react-phone-number-input';
import { roundToPreviousHalf, pluralize, formatDays, formatHoursAndMinutes } from '@webapps/utils';

const {
  colors: { background, subTitleColorEtablissement, titleColorEtablissement },
} = theme;


const LightTooltip = withStyles(({ shadows }) => ({
  tooltip: {
    backgroundColor: '#5D75A8',
    color: '#FFF',
    boxShadow: shadows[1],
    fontWeight: 600,
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14px' },
  },
}))(Tooltip);

const Business = ({ classroomId }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser, email } = useAuth();
  const [affiliationsFilter, setAffiliationFilter] = useState([]);
  const [invitation, setInvitation] = useState("");
  const [cancelContract, setCancelContract] = useState(false);

  const {
    data: { data: affiliations = [] } = {},
    refetch,
    isLoading: isLoadingAffiliation,
  } = useQuery(getStudentAffiliate, {
    key: ['studentAffiliateDashboardBusiness', idUser],
    variables: { id: idUser, type: 'business', status: 'all' },
  });

  const {
    data: { data: affiliations_school = [] } = {},
    isLoading: isLoadingAffiliationSchool,
  } = useQuery(getStudentAffiliate, {
    key: ['studentAffiliateDashboardSchool', idUser],
    variables: { id: idUser, type: 'school', status: 'enclosed' },
  });

  const { data: absenceData } = useQuery(getAbsenceHoursByStudentIdAndClassroomId, {
    key: ['absenceHoursByStudentIdAndClassroomId', idUser, classroomId, "COMPANY"],
    variables: { studentId: idUser, classId: classroomId, type: 'COMPANY' },
    enabled: !!classroomId
  });

  const { data: remainingDays } = useQuery(getRemainingDays, {
    key: ['remainingDays', classroomId],
    variables: { id: classroomId },
    enabled: !!classroomId
  });

  const filteredAffiliations = useMemo(() => affiliations.filter(({ status }) =>
    status !== 'REJECTED' &&
    status !== 'CANCELED' &&
    status !== 'BROKEN' &&
    status !== 'CONTRACT-BROKEN'
  ), [affiliations]);

  const {
    data: { data: affiliations_invites = [] } = {},
    refetch: refetchInvites,
    isLoading: isLoadingAffiliationInvites,
  } = useQuery(getAllInvitation, {
    key: ['studentAffiliateInviteDashboardBusiness', idUser + email],
    variables: { type: 'join_team', status: 'pending', email },
  });

  const refetchAll = () => {
    refetch();
    refetchInvites();
  };

  const filteredAffiliationsInviteByEmail = useMemo(() => affiliations_invites.filter(
    (invite) => invite?.student === email
  ), [affiliations_invites, email]);

  useEffect(() => {
    const combinedList = [
      ...filteredAffiliations.map(affiliation => ({ ...affiliation, type: 'affiliation' })),
      ...filteredAffiliationsInviteByEmail.map(invite => ({ ...invite, type: 'invitation' })),
    ];

    setAffiliationFilter(combinedList);
  }, [affiliations, affiliations_invites]);

  const [selectedInviteIndex, setSelectedInviteIndex] = useState(0);
  const organizationId = affiliationsFilter[selectedInviteIndex]?.organizationId;
  const groupId = affiliationsFilter[selectedInviteIndex]?.groupId;
  const jobId = affiliationsFilter[selectedInviteIndex]?.job;
  const contractId = affiliationsFilter[selectedInviteIndex]?.contractType;
  const invitationId = affiliationsFilter[selectedInviteIndex]?.id;

  const {
    data: businessData,
    isLoading: isLoadingBusinessData,
    error: businessDataError,
  } = useQuery(getBusinessById, {
    key: ['getBusinessById', organizationId],
    variables: { id: organizationId },
  });

  const isEnabled = (id) => {
    return typeof id === 'string' && id.trim() !== '';
  }

  const {
    data: jobDetails,
    isLoading: isLoadingJobsData,
    error: jobsDataError,
  } = useQuery(getJobsById, {
    key: ['getJobsById', jobId],
    variables: { id: jobId },
    enabled: isEnabled(jobId),
  });

  const {
    data: contractData,
    isLoading: isLoadingContractData,
    error: contractDataError,
  } = useQuery(getContractTypesById, {
    key: ['getContractTypesById', contractId],
    variables: { id: contractId },
    enabled: isEnabled(contractId),
  });

  const [activeStep, setActiveStep] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const maxSteps = affiliationsFilter?.length;

  const { push } = useRouter();

  const goToBusiness = (idBusiness) => {
    push(ROUTES_PATH.BUSINESS_VITRINE, { params: { id: idBusiness } });
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSelectedInviteIndex((prevSelectedInviteIndex) => prevSelectedInviteIndex + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setSelectedInviteIndex((prevSelectedInviteIndex) => prevSelectedInviteIndex - 1);
  };

  const [anchorCandid, setAnchorCandid] = useState(null);

  const openCandid = Boolean(anchorCandid);

  const handleClick = (event) => {
    setAnchorCandid(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorCandid(null);
  };

  const [openAffiliate, setOpenAffiliate] = useState(false);
  const [openInvitation, setOpenInvitation] = useState(false);

  const handleOpenInvitation = () => {
    setOpenInvitation(true);
  };

  const handleCloseInvitation = () => {
    setOpenInvitation(false);
  };

  const handleOpenAffiliate = () => {
    setOpenAffiliate(true);
  };
  const handleCloseAffiliate = () => {
    setOpenAffiliate(false);
  };

  const [openAffiliateCorrection, setOpenAffiliateCorrection] = useState(false);

  const handleOpenAffiliateCorrection = () => {
    setOpenAffiliateCorrection(true);
  };
  const handleCloseAffiliateCorrection = () => {
    setOpenAffiliateCorrection(false);
  };

  const { addToast } = useToast();

  const [openMessageBox, setOpenMessageBox] = useState(false);

  const handleOpenMessageBox = () => {
    setOpenMessageBox(true);
  };
  const handleCloseMessageBox = () => {
    setOpenMessageBox(false);
  };

  const [openQuitClass, setOpenQuitClass] = useState(false);

  const handleOpenQuitClass = () => {
    setOpenQuitClass(true);
  };

  const handleCloseQuitClass = () => {
    setOpenQuitClass(false);
  };

  const [cancelAffiliate, setCancelAffiliate] = useState(false);

  const {
    data: infosStudentOnTeam,
    isLoading: isLoadingGetInfoStudent,
    isSuccess: isSuccessGetInfoStudent,
    mutateAsync: mutateInfoStudent,
  } = useMutation(getInfoStudentOnTeam);

  const {
    error: errorMemberTeamAction,
    isLoading: isLoadingMemberTeamAction,
    isSuccess: isSuccessMemberTeamAction,
    mutateAsync: mutateSetMemberTeam,
  } = useMutation(setTeamMemberAction);

  const quitTeam = async () => {
    mutateInfoStudent({
      idTeam: affiliationsFilter[activeStep]?.student?.team?.id,
      idStudent: affiliationsFilter[activeStep]?.student?.id,
    });
  };

  useEffect(() => {
    if (isSuccessGetInfoStudent) {
      mutateSetMemberTeam({
        id: infosStudentOnTeam?.id,
        action: 'quit',
      });
    }
  }, [isSuccessGetInfoStudent]);

  useEffect(() => {
    if (isSuccessMemberTeamAction) {
      addToast({
        status: 'success',
        message: "Vous avez quitté l'équipe",
      });
      refetchAll();
      handleCloseQuitClass();
    }
  }, [isSuccessMemberTeamAction]);

  const [viewConfirmBreakContract, setViewConfirmBreakContract] =
    useState(false);

  const handleOpenViewConfirmBreakContract = () => {
    setViewConfirmBreakContract(true);
  };

  const handleCloseViewConfirmBreakContract = () => {
    setViewConfirmBreakContract(false);
  };

  const {
    error: errorBreakContract,
    isLoading: isLoadingBreakContract,
    isSuccess: isSuccessBreakContract,
    mutateAsync: mutateBreakContract,
  } = useMutation(breakContract);

  const breakStudentContract = () => {
    mutateBreakContract({
      id: affiliationsFilter[activeStep]?.contract?.id,
      actor: 'student',
      forEntity: 'business',
    });
  };

  const {
    error: errorAffiliateAction,
    isLoading: isLoadingAffiliateAction,
    isSuccess: isSuccessAffiliateAction,
    mutate: mutateSetAffiliateAction,
  } = useMutation(setAffiliateAction);

  const cancelAffiliateStudent = async () => {
    await mutateSetAffiliateAction({
      idAffiliate: affiliationsFilter[activeStep]?.id,
      action: 'broken',
    });
  };

  const {
    error: errorAction,
    isLoading: isLoadingAction,
    isSuccess: isSuccessAction,
    mutate: mutateSetAffiliateInviteAction,
  } = useMutation(responseInvitationAffiliation);

  const rejectAffiliation = async () => {
    await mutateSetAffiliateInviteAction({
      id: affiliationsFilter[activeStep]?.id,
      action: 'reject',
    });
  };

  const acceptAffiliation = async () => {
    await mutateSetAffiliateInviteAction({
      id: affiliationsFilter[activeStep]?.id,
      action: 'accept',
    });
  };

  useEffect(() => {
    if (errorBreakContract) {
      addToast({
        status: 'error',
        message: 'Erreur',
      });
    }
    if (isSuccessBreakContract) {
      addToast({
        status: 'success',
        message: 'Le contrat a été arrêté avec succès',
      });
      refetchAll();
      handleCloseViewConfirmBreakContract();
    }
  }, [isSuccessBreakContract, errorBreakContract]);

  useEffect(() => {
    if (errorAffiliateAction) {
      addToast({
        status: 'error',
        message: "Erreur pour annuler l'affiliation",
      });
    }
    if (isSuccessAffiliateAction) {
      addToast({
        status: 'success',
        message: 'Affiliation annulée avec succès',
      });
      refetchAll();
      setCancelAffiliate(false)
    }
  }, [isSuccessAffiliateAction, errorAffiliateAction]);

  useEffect(() => {
    if (errorAction) {
      invitation === "ACCEPTED" ?
        addToast({
          status: 'error',
          message: "Problème pour accepter l'invitation",
        })
        :
        addToast({
          status: 'error',
          message: "Problème pour refuser l'invitation",
        });
    }
    if (isSuccessAction) {
      invitation === "ACCEPTED" ?
        addToast({
          status: 'success',
          message: 'Invitation acceptée',
        })
        :
        addToast({
          status: 'success',
          message: 'Invitation rejeté',
        })


      refetchAll();
    }
  }, [isSuccessAction, errorAction]);

  return (
    <div className={classes.container}>
      <div
        className={css({ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' })}
      >
        <div className={classes.title} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <FormattedMessage id="student.dashboard.monEntreprise.title" />
          </div>
          {!affiliationsFilter?.length ?
            <LightTooltip open={showTooltip}
              onOpen={() => setShowTooltip(true)}
              onClose={() => setShowTooltip(false)} placement='top-start' title={`Rejoins une entreprise pour accéder aux fonctionnalités d'échanges de documents, de signature de contrat et de certifications d'expérience et de formation`}>
              <div onClick={() => setShowTooltip(!showTooltip)} style={{
                borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '30px', display: 'flex', justifyContent: 'center', height: '30px', alignItems: 'center', cursor: 'pointer', color: '#5A6DA1',
                '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
                '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
                fontFamily: 'Montserrat', fontWeight: 600
              }}>
                ?
              </div>
            </LightTooltip>

            :
            <>
              <IconButton
                onClick={handleClick}
                size="small"
                aria-controls={openCandid ? 'candidature-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openCandid ? 'true' : undefined}
                style={{ margin: '0px 3px', alignSelf: 'baseline', borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '26px', display: 'flex', justifyContent: 'center', height: '26px', alignItems: 'center', cursor: 'pointer' }}>
                <MoreHoriz style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
              </IconButton>
              <Menu
                anchorEl={anchorCandid}
                id="candidature-menu"
                open={openCandid}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{ elevation: 2 }}
                transformOrigin={{ horizontal: 'left', vertical: -50 }}
                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
              >
                {affiliationsFilter[activeStep]?.status === 'CREATED' && (
                  <MenuItem disableRipple disableFocusRipple className={css({
                    display: 'flex', alignItems: 'center', color: '#000000DE', fontWeight: 600, '&:hover': { backgroundColor: '#FFFFFF00' },
                    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                    '@media only screen and (max-width:1600px)': { fontSize: '14px' },
                  })} style={{ '&:hover': { backgroundColor: '#FFFFFF00' } }} onClick={handleOpenAffiliate}
                    size="small"
                  >
                    <FormattedMessage id="student.dashboard.monEcole.btnValiderAffiliation" />
                  </MenuItem>
                )}
                {(affiliationsFilter[activeStep]?.status === 'pending') && (
                  <>
                    <MenuItem disableRipple disableFocusRipple className={css({
                      display: 'flex', alignItems: 'center', color: '#000000DE', fontWeight: 600, '&:hover': { backgroundColor: '#FFFFFF00' },
                      '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                      '@media only screen and (max-width:1600px)': { fontSize: '14px' },
                    })} style={{ '&:hover': { backgroundColor: '#FFFFFF00' } }} onClick={() => { acceptAffiliation(); setInvitation("ACCEPTED") }}
                      size="small"
                    >
                      Valider l'affiliation
                    </MenuItem>
                    <MenuItem disableRipple disableFocusRipple className={css({
                      display: 'flex', alignItems: 'center', color: '#000000DE', fontWeight: 600, '&:hover': { backgroundColor: '#FFFFFF00' },
                      '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                      '@media only screen and (max-width:1600px)': { fontSize: '14px' },
                    })} style={{ '&:hover': { backgroundColor: '#FFFFFF00' } }} onClick={() => { rejectAffiliation(); setInvitation("REJECTED") }}
                      size="small"
                    >
                      Refuser l'affiliation
                    </MenuItem>
                  </>
                )}
                {(affiliationsFilter[activeStep]?.status === 'CREATED' || affiliationsFilter[activeStep]?.status === 'ACCEPTED' || affiliationsFilter[activeStep]?.status === 'HALF-REJECTED') && (
                  <MenuItem disableRipple disableFocusRipple className={css({
                    display: 'flex', alignItems: 'center', color: '#000000DE', fontWeight: 600, '&:hover': { backgroundColor: '#FFFFFF00' },
                    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                    '@media only screen and (max-width:1600px)': { fontSize: '14px' },
                  })} style={{ '&:hover': { backgroundColor: '#FFFFFF00' } }} onClick={() => setCancelAffiliate(true)}
                    size="small"
                  >
                    Annuler l'affiliation
                  </MenuItem>
                )}
                {affiliationsFilter[activeStep]?.status === 'HALF-REJECTED' && (
                  <MenuItem disableRipple disableFocusRipple className={css({
                    display: 'flex', alignItems: 'center', color: '#000000DE', fontWeight: 600, '&:hover': { backgroundColor: '#FFFFFF00' },
                    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                    '@media only screen and (max-width:1600px)': { fontSize: '14px' },
                  })} style={{ '&:hover': { backgroundColor: '#FFFFFF00' } }} onClick={handleOpenAffiliateCorrection}
                    size="small"
                    variant="contained"
                  >
                    Corriger
                  </MenuItem>
                )}
                {affiliationsFilter[activeStep]?.contract && affiliationsFilter[activeStep]?.contract.schoolSignAction !== null && affiliationsFilter[activeStep]?.contract.studentSignAction !== null && affiliationsFilter[activeStep]?.contract.businessSignAction !== null && (
                  <MenuItem disableRipple disableFocusRipple className={css({
                    display: 'flex', alignItems: 'center', color: '#000000DE', fontWeight: 600, '&:hover': { backgroundColor: '#FFFFFF00' },
                    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                    '@media only screen and (max-width:1600px)': { fontSize: '14px' },
                  })} style={{ '&:hover': { backgroundColor: '#FFFFFF00' } }} onClick={handleOpenViewConfirmBreakContract}
                    size="small"
                  >
                    Arrêter le contrat
                  </MenuItem>
                )}
                {affiliationsFilter[activeStep]?.opcoRecord?.opcoStatus && OPCO_STATUS.map(item => item.value).includes(affiliationsFilter[activeStep]?.opcoRecord?.opcoStatus) && (
                  <MenuItem disableRipple disableFocusRipple className={css({
                    display: 'flex', alignItems: 'center', color: '#000000DE', fontWeight: 600, '&:hover': { backgroundColor: '#FFFFFF00' },
                    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                    '@media only screen and (max-width:1600px)': { fontSize: '14px' },
                  })} style={{ '&:hover': { backgroundColor: '#FFFFFF00' } }} onClick={() => setCancelContract(true)}
                    size="small"
                  >
                    Arrêter le contrat
                  </MenuItem>
                )}
                {
                  affiliationsFilter[activeStep]?.status === 'ENCLOSED' &&
                  !affiliationsFilter[activeStep]?.contract &&
                  !affiliationsFilter[activeStep]?.opcoRecord?.opcoStatus && (
                    <MenuItem disableRipple disableFocusRipple className={css({
                      display: 'flex', alignItems: 'center', color: '#000000DE', fontWeight: 600, '&:hover': { backgroundColor: '#FFFFFF00' },
                      '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
                      '@media only screen and (max-width:1600px)': { fontSize: '14px' },
                    })} style={{ '&:hover': { backgroundColor: '#FFFFFF00' } }}
                      disabled={
                        isLoadingGetInfoStudent || isLoadingMemberTeamAction
                      }
                      onClick={handleOpenQuitClass}
                      size="small"
                    >
                      Quitter l'équipe
                    </MenuItem>
                  )}
                {/* <MenuItem onClick={handleOpenOffre} className={css({ textDecoration: 'none', display: 'flex', alignItems: 'center', color: '#000000DE' })}>
            Voir l'annonce
          </MenuItem> */}
              </Menu>
            </>
          }
        </div>
      </div>
      {!affiliationsFilter?.length ? (
        <div className={classes.noElement}>
          <p>Tu n'as pas encore d'entreprise affiliée. <br />
            Recherche des entreprises dans <Link to={ROUTES_PATH.MYMAP} style={{ textDecoration: 'none', color: '#0060F9' }}> Rechercher des offres </Link></p>
        </div>
      ) : (
        <>
          {affiliationsFilter[activeStep]?.type === 'affiliation' ? (
            <div>
              <div className={classes.flex}>
                <div className={classes.photo}>
                  <AvatarCompany
                    height={80}
                    idCompany={affiliationsFilter[activeStep]?.team?.business?.id || 'external'}
                    name={affiliationsFilter[activeStep]?.team?.business?.name || affiliations_school[activeStep]?.contract?.externalName}
                    width={80}
                  />
                </div>
                <div className={classes.profilName}>
                  <div className={classes.name}>
                    {affiliationsFilter[activeStep]?.team?.business?.name || affiliations_school[activeStep]?.contract?.externalName}
                    <div
                      className={css({
                        marginLeft: spacing(1),
                      })}
                    >
                      <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                    </div>
                  </div>
                  <div className={cx(global.infoText, classes.address)}>
                    <Room className={global.infoIcon} /> {
                      affiliationsFilter[activeStep]?.team?.business?.address
                        ?.cityCode || affiliations_school[activeStep]?.contract?.city
                    }{' '}
                    {
                      affiliationsFilter[activeStep]?.team?.business?.address
                        ?.city || ""
                    }
                  </div>
                </div>
              </div>
              <div>
                <div>
                  {affiliationsFilter[activeStep]?.status === 'CREATED' && (
                    <Button onClick={handleOpenAffiliate} className={classes.affiliationButton}>
                      Voir l'affiliation à compléter
                    </Button>
                  )}
                  {affiliationsFilter[activeStep]?.status === 'ACCEPTED' && (
                    <Button disableRipple className={classes.affiliationButtonNoHover}>
                      Affiliation : En attente du recruteur
                    </Button>
                  )}
                  {affiliationsFilter[activeStep]?.status === 'HALF-REJECTED' && (
                    <Button onClick={handleOpenAffiliateCorrection} className={css({
                      color: '#FA8100', border: 'none',
                      '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
                      '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
                      fontFamily: 'Roboto', fontWeight: '400', backgroundColor: '#FAE8D7', marginBottom: '20px', borderRadius: 10,
                    })}>
                      Affiliation : Document(s) à renvoyer
                    </Button>
                  )}
                  {affiliationsFilter[activeStep]?.status === 'ENCLOSED' && (
                    <Button disableRipple className={css({
                      color: '#158052', border: 'none',
                      '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
                      '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
                      fontFamily: 'Roboto', fontWeight: '400', backgroundColor: '#DBFAD8', marginBottom: '20px', borderRadius: 10, '&:hover': { color: '#158052', border: 'none', '@media only screen and (max-width:1920px)': { fontSize: '15.00px' }, '@media only screen and (max-width:1600px)': { fontSize: '14.00px' }, fontFamily: 'Roboto', fontWeight: '400', backgroundColor: '#DBFAD8', marginBottom: '20px', borderRadius: 10 }, cursor: 'default'
                    })}>
                      Lié(e) à l'entreprise
                    </Button>
                  )}
                </div>
              </div>
              <Divider
                className={css({
                  marginBottom: '20px',
                })}
              />
              <div className={classes.titleForm}>Votre poste</div>
              <div className={css({ marginTop: spacing(1) })}>
                <div
                  className={cx(global.infoText, classes.address)}
                >
                  <Work className={global.infoIcon} /> {affiliationsFilter[activeStep]?.job?.label || affiliations_school[activeStep]?.contract?.externalActivityLabel}
                </div>
                <div
                  className={cx(global.infoText, classes.address)}
                >
                  <DonutSmallIcon className={global.infoIcon} /> {affiliationsFilter[activeStep]?.job?.sector.label || affiliations_school[activeStep]?.contract?.externalActivityLabel}
                </div>
                <div
                  className={cx(global.infoText, classes.address)}
                >
                  <Description className={global.infoIcon} />  {affiliationsFilter[activeStep]?.contractType?.label || affiliations_school[activeStep]?.contract?.externalContractType}
                </div>
                {RYTHME_SCOLAIRE.filter(
                  ({ value }) =>
                    value === affiliationsFilter[0]?.contract?.schoolSystem
                )[0]?.label
                  &&
                  <div className={cx(global.infoText, classes.address)}>
                    <Schedule className={global.infoIcon} />
                    {
                      RYTHME_SCOLAIRE.filter(
                        ({ value }) =>
                          value === affiliationsFilter[0]?.contract?.schoolSystem
                      )[0]?.label
                    }
                  </div>
                }
                <div className={cx(global.infoText, classes.address)}>
                  <Phone className={global.infoIcon} />
                  {formatPhoneNumber(affiliationsFilter[activeStep]?.team?.business?.phone) || "Non renseigné"}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <Email className={global.infoIcon} />
                  {affiliationsFilter[activeStep]?.team?.business?.email || "Non renseigné"}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <EventBusy className={global.infoIcon} />
                  {!absenceData?.school ? 'Pas d\'absence' : `${formatDays(absenceData?.school)}  (${formatHoursAndMinutes(absenceData?.school)} d'absence)`}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <HourglassHalf className={global.infoIcon} />
                  {remainingDays?.entreprise || 0} {pluralize("jour", remainingDays?.entreprise)} {pluralize("restant", remainingDays?.entreprise)}
                </div>
                <div
                  className={cx(global.infoText, classes.address)}
                >
                  <CalendarToday className={global.infoIcon} />
                  {affiliationsFilter[activeStep]?.contract ? (
                    <>
                      <FormattedDate
                        day="numeric"
                        month="long"
                        value={affiliationsFilter[activeStep]?.contract?.startDate || affiliations_school[activeStep]?.contract?.startDate}
                        year="numeric"
                      />{' '}
                      au{' '}
                      <FormattedDate
                        day="numeric"
                        month="long"
                        value={affiliationsFilter[activeStep]?.contract?.endDate || affiliations_school[activeStep]?.contract?.endDate}
                        year="numeric"
                      />
                    </>)
                    :
                    <TeamMemberDetails idStudent={idUser} idTeam={affiliationsFilter[activeStep]?.student?.team?.id} />
                  }
                </div>
              </div>
            </div>
          ) : (
            <>
              <div>
                <div className={classes.flex}>
                  <div className={classes.photo}>
                    <AvatarCompany
                      height={80}
                      idCompany={affiliationsFilter[activeStep]?.organizationId}
                      name={businessData?.name}
                      width={80}
                    />
                  </div>
                  <div className={classes.profilName}>
                    <div className={classes.name}>
                      {businessData?.name}
                      <div
                        className={css({
                          marginLeft: spacing(1),
                        })}
                      >
                        <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                      </div>
                    </div>
                    <div className={cx(global.infoText, classes.address)}>
                      <Room fontSize='small' /> {businessData?.address?.cityCode}{' '} {businessData?.address?.city}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  {affiliationsFilter[activeStep]?.status === 'pending' && (
                    <Button className={css({
                      color: '#FA8100', border: 'none',
                      '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
                      '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
                      fontFamily: 'Roboto', fontWeight: '400', backgroundColor: '#FAE8D7', marginBottom: '20px', borderRadius: 10,
                    })} onClick={() => setOpenInvitation(true)}>
                      Affiliation : En attente de votre validation
                    </Button>
                  )}
                  {affiliationsFilter[activeStep]?.status === 'ENCLOSED' && (
                    <Button disableRipple className={css({
                      color: '#158052', border: 'none',
                      '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
                      '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
                      fontFamily: 'Roboto', fontWeight: '400', backgroundColor: '#DBFAD8', marginBottom: '20px', borderRadius: 10, '&:hover': { color: '#158052', border: 'none', '@media only screen and (max-width:1920px)': { fontSize: '15.00px' }, '@media only screen and (max-width:1600px)': { fontSize: '14.00px' }, fontFamily: 'Roboto', fontWeight: '400', backgroundColor: '#DBFAD8', marginBottom: '20px', borderRadius: 10 }, cursor: 'default'
                    })}>
                      Lié(e) à l'entreprise
                    </Button>
                  )}
                </div>
              </div>
              <Divider
                className={css({
                  marginBottom: spacing(2),
                })}
              />
              <div className={classes.titleForm}>Votre poste</div>
              <div className={css({ marginTop: spacing(1) })}>
                <div className={cx(global.infoText, classes.address)}>
                  <Work className={global.infoIcon} /> {jobDetails?.label || affiliations_school[activeStep]?.contract?.externalActivityLabel}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <DonutSmallIcon className={global.infoIcon} /> {jobDetails?.sector?.label || affiliations_school[activeStep]?.contract?.externalActivityLabel}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <Description className={global.infoIcon} />  {contractData?.label || affiliations_school[activeStep]?.contract?.externalContractType}
                </div>
                {RYTHME_SCOLAIRE.filter(
                  ({ value }) =>
                    value === affiliationsFilter[0]?.contract?.schoolSystem
                )[0]?.label
                  &&
                  <div className={cx(global.infoText, classes.address)}>
                    <Schedule className={global.infoIcon} />
                    {
                      RYTHME_SCOLAIRE.filter(
                        ({ value }) =>
                          value === affiliationsFilter[0]?.contract?.schoolSystem
                      )[0]?.label
                    }
                  </div>
                }
                <div className={cx(global.infoText, classes.address)}>
                  <Phone className={global.infoIcon} />
                  {formatPhoneNumber(businessData?.phone) || "Non renseigné"}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <Email className={global.infoIcon} />
                  {businessData?.email || "Non renseigné"}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <EventBusy className={global.infoIcon} />
                  {!absenceData?.school ? 'Pas d\'absence' : `${roundToPreviousHalf(absenceData?.school / 7)} ${pluralize("jour", roundToPreviousHalf(absenceData?.school / 7))}  (${absenceData?.school} ${pluralize("heure", absenceData?.school)} d'absence)`}
                </div>
                <div className={cx(global.infoText, classes.address)}>
                  <HourglassHalf className={global.infoIcon} />
                  {remainingDays?.entreprise || 0} {pluralize("jour", remainingDays?.entreprise)} {pluralize("restant", remainingDays?.entreprise)}
                </div>
                <div
                  className={cx(global.infoText, classes.address)}
                >
                  <DateRange className={global.infoIcon} />
                  {affiliationsFilter[activeStep]?.contract ? (
                    <>
                      <FormattedDate
                        day="numeric"
                        month="long"
                        value={affiliationsFilter[activeStep]?.contract?.startDate || affiliations_school[activeStep]?.contract?.startDate}
                        year="numeric"
                      />{' '}
                      au{' '}
                      <FormattedDate
                        day="numeric"
                        month="long"
                        value={affiliationsFilter[activeStep]?.contract?.endDate || affiliations_school[activeStep]?.contract?.endDate}
                        year="numeric"
                      />
                    </>)
                    :
                    <TeamMemberDetails idStudent={idUser} idTeam={groupId} />
                  }
                </div>
              </div>
            </>
          )}

          {affiliationsFilter.length > 1 && (
            <MobileStepper
              activeStep={activeStep}
              backButton={
                <Button
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  size="small"
                >
                  {theme.direction === 'rtl' ? (
                    <KeyboardArrowRight />
                  ) : (
                    <KeyboardArrowLeft />
                  )}
                </Button>
              }
              className={css({ marginTop: spacing(2) })}
              nextButton={
                <Button
                  disabled={activeStep === maxSteps - 1}
                  onClick={handleNext}
                  size="small"
                >
                  {theme.direction === 'rtl' ? (
                    <KeyboardArrowLeft />
                  ) : (
                    <KeyboardArrowRight />
                  )}
                </Button>
              }
              position="static"
              steps={maxSteps}
              variant="text"
            />
          )}

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                fullWidth
                onClick={handleOpenMessageBox}
                style={{ backgroundColor: '#F3F7FF', marginTop: '10px' }}
                variant="outlined"
              >
                <FormattedMessage id="student.dashboard.monEcole.btnContacter" />
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                onClick={() => goToBusiness(affiliationsFilter[activeStep]?.team?.business?.id)}
                style={{ backgroundColor: '#F3F7FF', marginTop: '10px' }}
                variant="outlined"
              >
                Voir la vitrine
              </Button>
            </Grid>
          </Grid>
        </>
      )}
      <Modal
        onCancel={handleCloseAffiliate}
        open={openAffiliate}
        subTitle="Une entreprise souhaite vous affilier."
        title="Demande d'affiliation"
        withStep={false}
      >
        <Affiliate
          close={handleCloseAffiliate}
          data={affiliationsFilter[activeStep]}
          refetch={refetchAll}
        />
      </Modal>
      <Modal
        onCancel={handleCloseInvitation}
        open={openInvitation}
        subTitle="Une entreprise vous invite dans son équipe."
        title="Invitation"
        withStep={false}
      >
        <Invite
          close={handleCloseInvitation}
          jobData={jobDetails}
          contractData={contractData}
          businessData={businessData}
          invitationId={invitationId}
          refetch={refetchAll}
          type={"business"}
        />
      </Modal>
      <Modal
        onCancel={handleCloseAffiliateCorrection}
        open={openAffiliateCorrection}
        subTitle="Une entreprise souhaite vous affilier."
        title="Demande d'affiliation"
        withStep={false}
      >
        <AffiliateCorrection
          close={handleCloseAffiliateCorrection}
          data={affiliationsFilter[activeStep]}
          refetch={refetchAll}
        />
      </Modal>
      <Modal
        onCancel={handleCloseMessageBox}
        open={openMessageBox}
        // subTitle="Gardez contact dans votre
        // messagerie avec votre entreprise"
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({ display: 'flex', flexDirection: 'row' })}>
          <span>
            <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
          </span>
          <div>
            Gardez contact dans votre
            messagerie avec votre entreprise
          </div>
        </div>
        <MessageBox
          id={affiliationsFilter[activeStep]?.classroom?.school?.id}
          onCancel={handleCloseMessageBox}
        />
      </Modal>
      <ModalConfirm
        cancelBtnTitle="Non"
        confirmBtnTitle="Oui"
        confirmFunction={quitTeam}
        isLoading={isLoadingGetInfoStudent || isLoadingMemberTeamAction}
        onClose={handleCloseQuitClass}
        open={openQuitClass}
        title="Quitter l'équipe"
      >
        Êtes-vous sûr de vouloir quitter l'équipe ?
      </ModalConfirm>
      <ModalConfirm
        cancelBtnTitle="Non"
        confirmBtnTitle="Oui"
        confirmFunction={breakStudentContract}
        isLoading={isLoadingBreakContract}
        onClose={handleCloseViewConfirmBreakContract}
        open={viewConfirmBreakContract}
        title="Arrêter le contrat"
      >
        Êtes-vous sûr de vouloir arrêter le contrat ?
      </ModalConfirm>
      <ModalConfirm
        cancelBtnTitle="Non"
        confirmBtnTitle="Oui"
        confirmFunction={cancelAffiliateStudent}
        isLoading={isLoadingAffiliateAction}
        onClose={() => setCancelAffiliate(false)}
        open={cancelAffiliate}
        title="Annuler l'affiliation"
      >
        Êtes-vous sûr de vouloir annuler l'affiliation ?
      </ModalConfirm>
      <Modal
        onCancel={() => setCancelContract(false)}
        open={cancelContract}
        title="Rompre le contrat"
        withStep={false}
      >
        <div className={global.fcac}>
          <div>Veuillez contacter votre organisme de formation pour rompre le contrat</div>
          <Button
            color="primary"
            variant="contained"
            className={css({ borderRadius: 1000 })}
            onClick={() => setCancelContract(false)}
          >
            Ok
          </Button>
        </div>
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    flex: '1 1 0px',
    borderRadius: 10,
    padding: '20px',
    minHeight: '400px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '100%',
  },
  affiliationButton: {
    color: '#FA8100',
    fontFamily: 'Roboto',
    fontWeight: 400,
    backgroundColor: '#FAE8D7',
    marginBottom: '20px', // Use '2rem' or an appropriate value if you're using rem for spacing
    borderRadius: '10px',
    border: 'none', // Remove default borders
    cursor: 'pointer', // Change the cursor on hover
    '&:hover': {
      backgroundColor: '#FFE1AA',
    },
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
  },
  affiliationButtonNoHover: {
    color: '#FA8100',
    fontFamily: 'Roboto',
    fontWeight: 400,
    backgroundColor: '#FAE8D7',
    marginBottom: '20px', // Use '2rem' or an appropriate value if you're using rem for spacing
    borderRadius: '10px',
    border: 'none', // Remove default borders
    '&:hover': {
      backgroundColor: '#FAE8D7',
    },
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
  },
  inviteActionButton: {
    backgroundColor: '#0060F9',
    borderRadius: '10px',
    color: '#FFFFFF',
    fontFamily: 'Roboto',
    fontWeight: 400,
    width: '40%',
    marginTop: '20px',
    '&:hover': {
      backgroundColor: '#0050D3',
    },
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
  },
  inviteActionButtonDecline: {
    backgroundColor: '#F80000',
    borderRadius: '10px',
    color: '#FFFFFF',
    fontFamily: 'Roboto',
    fontWeight: 400,
    width: '40%',
    marginTop: '20px',
    '&:hover': {
      backgroundColor: '#BB0000',
    },
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
  },
  title: {
    fontWeight: 600,
    color: '#152652',
    fontFamily: 'Montserrat',
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
  },
  titleForm: {
    fontWeight: 600,
    color: '#152652',
    fontFamily: 'Montserrat',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14px' },
  },
  flex: {
    display: 'flex',
    marginTop: spacing(2),
    marginBottom: '20px',
  },
  profilName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: spacing(2),
  },
  avatar: {
    height: 80,
    width: 80,
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Montserrat',
    color: titleColorEtablissement,
    fontWeight: 600,
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14px' },

  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(0.5),
  },
  noElement: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14px' },

  },
});

export default Business;

const TeamMemberDetails = ({ idStudent, idTeam }) => {
  const { data: teamMemberDetails = {} } = useQuery(getInfoStudentOnTeam, {
    key: ['studentTeamMemberDetails', idStudent, idTeam],
    variables: { idStudent, idTeam },
  });

  return (
    (teamMemberDetails?.joinDate && (
      <FormattedDate
        day="numeric"
        month="long"
        value={teamMemberDetails?.joinDate}
        year="numeric"
      />
    )) ||
    'Non rejoint'
  );
};

TeamMemberDetails.propTypes = {
  idStudent: PropTypes.string,
  idTeam: PropTypes.string,
};

